import { Link } from 'react-router-dom';
import { ROUTES } from '@/lib/constants/routes';
import { Button } from '@/components/ui/Button';

export function NotFoundPage() {
  return (
    <div className="min-h-screen bg-page-bg flex flex-col items-center justify-center px-6 text-center">
      <p className="text-8xl font-bold text-navy opacity-10 select-none" aria-hidden="true">
        404
      </p>
      <h1 className="mt-4 text-2xl font-bold text-navy">Page not found</h1>
      <p className="mt-2 text-slate max-w-sm">
        The page you&apos;re looking for doesn&apos;t exist or has been moved.
      </p>
      <Button asChild className="mt-8 px-6 py-3 text-sm">
        <Link to={ROUTES.HOME}>Back to home</Link>
      </Button>
    </div>
  );
}
